<template src="./TerapiasEsquema.html"> </template>

<script>
import TarjetasEsquemas from "./TarjetasEsquemas/TarjetasEsquemas";
import { leerLista, readSchemes } from "../../../apiService/request/CrudTerapias";
export default {
  data() {
    return {
			therapiesItems: [],
			therapySelected: null,
      schemesItems: []
    };
  },
  async mounted() {
    this.$parent.$emit("navContent", 1);
		await this.getTherapiesList();
  },
  methods: {
    async getTherapiesList() {
      try {
				this.$store.dispatch("setCargando", true);
        const respuesta = await leerLista("terapias_planb");
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.therapiesItems = respuesta.data.data;
        }
      } catch (err) {
        console.log(err);
      } finally {
				this.$store.dispatch("setCargando", false);
			}
		},
		async getClusters() {
			try {
				this.$store.dispatch("setCargando", true);
        const respuesta  = await readSchemes(this.therapySelected);
        if (respuesta && respuesta.data && respuesta.data.data) {
          this.schemesItems = respuesta.data.data;
        }
			} catch(err)  {
				console.log(err);
			} finally {
				this.$store.dispatch("setCargando", false);
			}
		}
  },
  components: {
    TarjetasEsquemas
  }
};
</script>

<style src="./TerapiasEsquema.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Terapias/TerapiasEsquema/TerapiasEsquema.vue